import { useContext } from 'react'

import KanbanBoardContext from 'contexts/KanbanBoardContext'

const useKanbanBoard = () => {
  const context = useContext(KanbanBoardContext)

  if (context === undefined) {
    throw new Error('useKanbanBoard must be used within a KanbanBoardProvider')
  }

  return context
}

export default useKanbanBoard
